require('./_wks-define')('asyncIterator');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/babel-polyfill/~/core-js/modules/es7.symbol.async-iterator.js
 ** module id = 2015
 ** module chunks = 0
 **/